import _implicitStylesheets from "./header.css";
import _implicitScopedStylesheets from "./header.scoped.css?scoped=true";
import _pageLink from "page/link";
import _appxHeaderAppLauncher from "appx/headerAppLauncher";
import _appxHeaderMenu from "appx/headerMenu";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a href="/"${"a0:title"} data-test-id="salesforce-logo"${3}><img${"a1:src"} height="40" width="60"${"a1:alt"}${3}></a>`;
const $fragment2 = parseFragment`<div class="menu-item app-name${0}"${2}><h1${3}>${"t2"}</h1></div>`;
const $fragment3 = parseFragment`<span class="slds-assistive-text${0}"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<span class="slds-truncate${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment5 = parseFragment`<a${"a0:href"} data-test-id="appexchange" class="slds-text-title_bold${0}" target="_blank"${2}>${"t1"}</a>`;
const $fragment6 = parseFragment`<div class="menu-item${0}"${2}><img${"a1:src"} height="60" width="85" class="appy${0}"${"a1:alt"}${2}></div>`;
const $fragment7 = parseFragment`<span class="slds-assistive-text${0}"${2}>${"t1"}</span>`;
const $fragment8 = parseFragment`<span class="slds-truncate${0}"${"a0:title"}${2}>${"t1"}</span>`;
const $fragment9 = parseFragment`<div class="right${0}"${2}></div>`;
const stc0 = {
  classMap: {
    "slds-global-header_container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "top": true,
    "slds-grid": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "top-inner": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "left": true
  },
  attrs: {
    "data-test-id": "left-header-nav",
    "role": "navigation",
    "aria-label": "primary"
  },
  key: 3
};
const stc4 = {
  classMap: {
    "menu-item": true
  },
  key: 4
};
const stc5 = {
  key: 5
};
const stc6 = {
  classMap: {
    "menu-item": true,
    "slds-grid": true
  },
  key: 10
};
const stc7 = {
  key: 12
};
const stc8 = {
  key: 13
};
const stc9 = {
  "menu-link": true
};
const stc10 = {
  classMap: {
    "right": true
  },
  key: 19
};
const stc11 = {
  classMap: {
    "menu-item": true
  },
  key: 20
};
const stc12 = {
  key: 21
};
const stc13 = {
  classMap: {
    "menu-item": true
  },
  key: 24
};
const stc14 = {
  key: 25
};
const stc15 = {
  classMap: {
    "menu-item": true,
    "publisher-menu-item": true
  },
  key: 26
};
const stc16 = {
  classMap: {
    "menu-item": true,
    "user-menu": true
  },
  key: 28
};
const stc17 = {
  classMap: {
    "bottom": true,
    "slds-grid": true
  },
  key: 30
};
const stc18 = {
  classMap: {
    "bottom-inner": true
  },
  key: 31
};
const stc19 = {
  classMap: {
    "left": true
  },
  key: 32
};
const stc20 = {
  classMap: {
    "sub-nav": true,
    "menu-item": true,
    "slds-grid": true
  },
  attrs: {
    "role": "navigation",
    "aria-label": "secondary"
  },
  key: 35
};
const stc21 = {
  classMap: {
    "menu-item": true,
    "slds-grid": true
  },
  key: 36
};
const stc22 = {
  classMap: {
    "sub-nav-item-container": true
  },
  key: 38
};
const stc23 = {
  key: 39
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, d: api_dynamic_text, ncls: api_normalize_class_name, k: api_key, i: api_iterator} = $api;
  return [api_element("header", stc0, [api_element("div", stc1, [api_element("div", stc2, [api_element("div", stc3, [api_element("div", stc4, [api_custom_element("page-link", _pageLink, stc5, [api_static_fragment($fragment1, 7, [api_static_part(0, {
    attrs: {
      "title": $cmp.sharedLabels.salesforceLogo
    }
  }, null), api_static_part(1, {
    attrs: {
      "src": $cmp.images.salesforceLogo,
      "alt": $cmp.sharedLabels.salesforceLogo
    }
  }, null)])])]), api_static_fragment($fragment2, 9, [api_static_part(2, null, api_dynamic_text($cmp.labels.appName))]), api_element("ul", stc6, api_iterator($cmp.menu, function (item) {
    return api_element("li", {
      className: api_normalize_class_name(item.styleclass),
      key: api_key(11, item.name)
    }, [api_element("div", stc7, [api_custom_element("page-link", _pageLink, stc8, [api_element("a", {
      classMap: stc9,
      attrs: {
        "href": item.href,
        "title": item.name,
        "data-test-id": item.name
      },
      key: 14
    }, [item.active ? api_static_fragment($fragment3, 16, [api_static_part(1, null, api_dynamic_text($cmp.labels.currentPageLabel))]) : null, api_static_fragment($fragment4, 18, [api_static_part(0, {
      attrs: {
        "title": item.name
      }
    }, null), api_static_part(1, null, api_dynamic_text(item.name))])])])])]);
  }))]), api_element("div", stc10, [api_element("div", stc11, [api_custom_element("page-link", _pageLink, stc12, [api_static_fragment($fragment5, 23, [api_static_part(0, {
    attrs: {
      "href": $cmp.appexchangeLink
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.goToAppexchange))])])]), api_element("div", stc13, [api_custom_element("appx-header-app-launcher", _appxHeaderAppLauncher, stc14)]), $cmp.publisher ? api_element("div", stc15, [api_custom_element("appx-header-menu", _appxHeaderMenu, {
    props: {
      "menuName": "publisher-menu",
      "menuItems": $cmp.publisherMenuItems,
      "imageUrl": $cmp.publisherLogoUrl,
      "imageAlt": $cmp.publisher.name
    },
    key: 27
  })]) : null, $cmp.userData ? api_element("div", stc16, [api_custom_element("appx-header-menu", _appxHeaderMenu, {
    props: {
      "menuName": "user-menu",
      "menuItems": $cmp.userMenuItems,
      "imageUrl": $cmp.userProfilePhotoUrl,
      "imageAlt": $cmp.userData.name
    },
    key: 29
  })]) : null])])]), api_element("div", stc17, [api_element("div", stc18, [api_element("div", stc19, [api_static_fragment($fragment6, 34, [api_static_part(1, {
    attrs: {
      "src": $cmp.images.appyHeader,
      "alt": $cmp.labels.appyName
    }
  }, null)]), api_element("div", stc20, [api_element("ul", stc21, api_iterator($cmp.submenuOptions, function (subitem) {
    return api_element("li", {
      className: api_normalize_class_name(subitem.styleclass),
      key: api_key(37, subitem.name)
    }, [api_element("div", stc22, [api_custom_element("page-link", _pageLink, stc23, [api_element("a", {
      attrs: {
        "href": subitem.href,
        "title": subitem.name,
        "data-test-id": "subitem-link"
      },
      key: 40
    }, [subitem.active ? api_static_fragment($fragment7, 42, [api_static_part(1, null, api_dynamic_text($cmp.labels.currentPageLabel))]) : null, api_static_fragment($fragment8, 44, [api_static_part(0, {
      attrs: {
        "title": subitem.name
      }
    }, null), api_static_part(1, null, api_dynamic_text(subitem.name))])])])])]);
  }))])]), api_static_fragment($fragment9, 46)])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-660m2tk1ijv";
tmpl.legacyStylesheetToken = "appx-header_header";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
